import { FC, useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'
import { useSetRecoilState } from 'recoil'
import { getContracts } from '../../../api/miContracts'
import { requestState } from '../../../states/atoms'
import { PageNation } from '../../PageNation'
import { ListItemSection } from './listItem'

const LIMIT = 12 // 1ページに表示する件数

export const ContractsSection: FC = () => {
  const query = new URLSearchParams(useLocation().search)
  const pageQuery = Number(query.get('page')) || 1

  const [page, setPage] = useState(pageQuery)
  const paramsForGet = { page, limit: LIMIT }
  const { data, error, mutate } = getContracts(paramsForGet) // キャッシュ機能あり
  const setRequestState = useSetRecoilState(requestState)

  const goNext = () => {
    setPage(page + 1)
    history.replaceState('', '', `contracts?page=${page + 1}`)
  }

  const goBack = () => {
    setPage(page - 1)
    history.replaceState('', '', `contracts?page=${page - 1}`)
  }

  useEffect(() => {
    window.scroll({ top: 0, behavior: 'smooth' })
  }, [page])

  // 接続タイムアウトのハンドリング
  if (typeof data === 'string') {
    {
      return (
        <>
          <div className="listBody containerBase">
            <Container>
              <Row>
                <Col className="text-center">保証契約が取得できませんでした。時間を置いて再度お試しください。</Col>
              </Row>
            </Container>
          </div>
        </>
      )
    }
  }

  if (error) {
    setRequestState({
      errorMessage: `保証契約が取得できませんでした。\n時間を置いて再度お試しください。`,
    })
  }

  const totalNumber = data?.totalNumber
  const contracts = data?.contracts

  return (
    <>
      <div className="listBody containerBase">
        <Container>
          <Row>
            <Col>
              <div className="section">購入履歴</div>
            </Col>
          </Row>
          {!(contracts && totalNumber) ? (
            data ? (
              <Row>
                <Col className="text-center">メールアドレスに紐づいた保証契約が見つかりませんでした。</Col>
              </Row>
            ) : (
              <></>
            )
          ) : (
            <>
              <Row>
                {contracts?.map((contract) => (
                  <ListItemSection key={contract.id} contract={contract} />
                ))}
              </Row>
              {totalNumber > LIMIT ? (
                <Row>
                  <PageNation
                    page={page}
                    goBack={goBack}
                    goNext={goNext}
                    limit={LIMIT}
                    count={contracts.length}
                    total={totalNumber}
                  />
                </Row>
              ) : (
                <></>
              )}
            </>
          )}
        </Container>
      </div>
    </>
  )
}
